module.exports = __webpack_public_path__ + "img/img_community-nights.1d451c26.jpg";